import React, { useState } from 'react';
import EmailContext from './EmailContext';

const EmailProvider = ({ children }) => {
    const [emailValues, setEmailValues] = useState({});

    const handleEmailValues = (params) => {
        setEmailValues(params);
    };
    const resetEmailValues = () => {
        setEmailValues({})
    }


    return (
        <EmailContext.Provider value={{ emailValues, handleEmailValues, resetEmailValues }}>
            {children}
        </EmailContext.Provider>
    );
};

export default EmailProvider